<template>
  <v-container>
    <h1>Feedback</h1>
    <v-form>
      <v-select v-model="input.feedbackType" :items="feedbackOptions" label="Category" />
      <v-textarea v-model="input.comment" label="Comments" />
      <v-btn @click="submit" color="primary"> Submit </v-btn>
    </v-form>
    <v-dialog v-model="success" max-width="600px">
      <v-card>
        <v-card-text class="pa-12">
          <div class="text-h2 text-center">Thank you for your feedback!</div>
        </v-card-text>
        <v-card-actions>
          <v-btn :to="{ name: 'home' }" exact> Home </v-btn>
          <v-spacer />
          <v-btn @click="success = false"> More Feedback </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="fail" max-width="600px">
      <v-card>
        <v-card-text class="pa-12">
          <div class="text-h2 text-center red--text">An error occurred</div>
        </v-card-text>
        <v-card-actions class="flex justify-center">
          <v-btn @click="fail = false"> Close </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
export default {
  name: "FeedbackPage",
  data: () => ({
    input: {
      feedbackType: "",
      comment: "",
    },
    feedbackOptions: ["Bug Report", "Suggestion"],
    success: false,
    fail: false,
  }),
  methods: {
    submit() {
      this.$axios
        .post("/feedback", {
          category: this.input.feedbackType,
          comment: this.input.comment,
        })
        .then(() => {
          this.success = true;
        })
        .catch(() => {
          this.fail = true;
        })
        .finally(() => {
          this.input.feedbackType = "";
          this.input.comment = "";
        });
    },
  },
};
</script>
